import { render, staticRenderFns } from "./ModalReceive.vue?vue&type=template&id=2e213e30&scoped=true"
import script from "./ModalReceive.vue?vue&type=script&lang=js"
export * from "./ModalReceive.vue?vue&type=script&lang=js"
import style0 from "./ModalReceive.vue?vue&type=style&index=0&id=2e213e30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e213e30",
  null
  
)

export default component.exports